import { lazy } from "react";

const Dashboard = lazy(() => import("../components/admin/dashboard/Index"));
const Customers = lazy(() => import("../components/admin/customers/Index"));
const Partners = lazy(() => import("../components/admin/partners/Index"));
const Pricing = lazy(() => import("../components/admin/Pricing"));
const Promotion = lazy(() => import("../components/admin/promotion/Index"));
const AccessLogs = lazy(() => import("../components/admin/AccessLogs"));
import { MODULE, SUBMODULE } from '../constants/user-management.constant';

const AdminRoutes = [
    { path: '/dashboard/:tab?', id: 'ADMIN_DASHBOARD', moduleIds: [MODULE.ADMIN_DASHBOARD], element: <Dashboard />, base: '/dashboard' },
    { path: '/customers/:id?', id: 'CUSTOMER', moduleIds: [MODULE.CLIENTS], element: <Customers />, base: '/customers' },
    { path: '/partners/:id?', id: 'PARTNER', moduleIds: [MODULE.PARTNERS], element: <Partners />, base: '/partners' },
    { path: '/pricing', id: 'PRICING', moduleIds: [MODULE.PRICING], element: <Pricing />, base: '/pricing' },
    { path: '/promotion/:tab?', id: 'PROMOTION', moduleIds: [MODULE.PROMO_CODE], element: <Promotion />, base: '/promotion' },
    { path: '/access-logs', id: 'ACCESS_LOGS', moduleIds: [MODULE.ADMIN_PROFILE], subModuleIds: [SUBMODULE.ADMIN_ACCESS_LOG], element: <AccessLogs />, base: '/access-logs' },
];

export default AdminRoutes;